const ALL_SEVERITIES = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark']
type severitiesTuple = typeof ALL_SEVERITIES;
export type severity = severitiesTuple[number]
export function toSeverity(input: string): severity {
    if (ALL_SEVERITIES.includes(input)) {
        return input as severity;
    }
    return 'danger';
}

export interface InformationBanner {
    id: string,
    name: string,
    bannerText: string,
    icon: string,
    severity: severity,
};
